export default function isIE11() {
  return !!window.MSInputMethodContext && !!document.documentMode;
}



// WEBPACK FOOTER //
// ./scripts/util/isIE11.js